import { cn } from "@/lib/utils/cn";
import { FaArrowRightLong } from "react-icons/fa6";
import { ghostCtaBase } from "./ghostCtaStyles";
import Link from "next/link";

const goldPrimaryCtaButtonStyles = `${ghostCtaBase} border-transparent text-black bg-ghost-gold/80 hover:bg-ghost-gold`;
const redPrimaryCtaButtonStyles = `${ghostCtaBase} border-transparent text-white bg-ghost-red/80 hover:bg-ghost-red`;

type Props = {
  href: string;
  label: string;
  className?: string;
  internal?: boolean;
  variant?: "red" | "gold";
};

export default function PrimaryCTAButton({
  href,
  label,
  className,
  internal = true,
  variant = "gold",
}: Props) {
  const stylesToUse =
    variant === "gold" ? goldPrimaryCtaButtonStyles : redPrimaryCtaButtonStyles;
  if (internal) {
    return (
      <Link href={href} className={cn(className, stylesToUse)}>
        <span>{label}</span>
        <FaArrowRightLong size={14} aria-hidden="true" />
      </Link>
    );
  } else {
    return (
      <a
        href={href}
        className={cn(className, stylesToUse)}
        target="_blank"
        rel="nofollow noopener"
      >
        <span>{label}</span>
        <FaArrowRightLong size={14} aria-hidden="true" />
      </a>
    );
  }
}
